import type { ProgressRepo } from '../ports/progress.ts';
import type { KeyValueStorage } from '../ports/storage.ts';
import { progressKey } from '../web/local-progress-repo.ts';
import { marksKey, ownerKey, readKey, readStash, removeKey, stashKey } from './sync-storage.ts';

export interface PurgeProgressOptions {
  storage: KeyValueStorage;
  userId: string;
  /** Every class the app writes (the storage port cannot list keys). */
  licenseClasses: readonly string[];
  /** The local repo over `storage`: when given, screens are told the records are gone. */
  local?: ProgressRepo;
  namespace?: string;
}

/**
 * Removes everything this device keeps of `userId`'s study progress (account deletion, explicit
 * sign-out): their session-expiry stash and, when the local records belong to them (owner marker),
 * the records of `licenseClasses`, their sync marks and the owner marker. Guest data and another
 * user's data are left alone. Never throws.
 */
export function purgeProgressForUser(options: PurgeProgressOptions): void {
  const { storage, userId, local } = options;
  const namespace = options.namespace ?? 'dcs';
  const stash = readStash(storage, namespace);
  if (stash !== null && stash.userId === userId) removeKey(storage, stashKey(namespace));
  if (readKey(storage, ownerKey(namespace)) !== userId) return;
  for (const licenseClass of options.licenseClasses) {
    if (local) local.reset(licenseClass);
    else removeKey(storage, progressKey(licenseClass, namespace));
    removeKey(storage, marksKey(licenseClass, namespace));
  }
  removeKey(storage, ownerKey(namespace));
}
